(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["get-shade-page-no-schedule"]) return;
  try {
    
  window.addEventListener('load', () => {
      let target = document.getElementById('findationBlock');

      if(target) {
          target.classList.remove('opacity-0');
      }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["get-shade-page"]) return;
  try {
    
    window.addEventListener('load', () => {
        let target = document.getElementById('findationBlock');

        if(target) {
            target.classList.remove('opacity-0');
        }
    }); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layout-footer"]) return;
  try {
    
class CustomAccordion extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      button: this.querySelectorAll('.custom-accordion'),
    };
  }

  toggleAccordion(item) {
    let intViewportWidth = window.innerWidth;

    if(intViewportWidth < 768) {
      if(item != undefined && item.classList.contains('open') ) {
        item.classList.remove('open'); 
        item.querySelector('.accordion__icon--closed').style.opacity = 1;
        item.querySelector('.accordion__icon--open').style.display = 'none';
        if(item.querySelector('ul')) {
          item.querySelector('ul').style.height = '0';
        }
  
      } else if(item != undefined) {
        item.classList.add('open'); 
        item.querySelector('.accordion__icon--closed').style.opacity = 0;
        item.querySelector('.accordion__icon--open').style.display = 'block';
        if(item.querySelector('ul')) {
          item.querySelector('ul').style.height = 'auto';
        }
      }
    }
  }

  connectedCallback() {
    this.querySelectorAll('.custom-accordion').forEach(item => item.addEventListener('click', this.toggleAccordion.bind(this, item)));

  }

  
}

customElements.define('custom-accordion', CustomAccordion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layout-header"] && !window.DesignMode) return;
  try {
    
window.addEventListener('load', () => {
typeof Header !== 'undefined' && new Header();
typeof CartDrawer !== 'undefined' && new CartDrawer();
if (typeof CartBundleItems !== 'undefined') window.cartBundleItems = new CartBundleItems();

});


  } catch(e) { console.error(e); }
})();
})();
